class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

renderContents(parsedState) {
  this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    this.querySelector('.drawer__inner').classList.remove('is-empty');

  // ⭐ Get the variant ID from parsedState
  const variantId = parsedState.id;

  // ⭐ Fetch the cart to map variant → product
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const matchingItem = cart.items.find(i => i.variant_id === variantId);
      this.productId = matchingItem ? matchingItem.product_id : null;

      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (!sectionElement) return;
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });

      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });

      // ⭐ Delay to ensure drawer is fully rendered
      setTimeout(() => {
        fetchComplementaryProducts(this.productId);
      }, 150);
    });
}



  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// ---- Complementary products ----

function fetchComplementaryProducts(productId) {
  if (!productId) return;

  fetch(`/recommendations/products.json?product_id=${productId}&intent=complementary&limit=3
`)
    .then((res) => res.json())
    .then((data) => {
      renderComplementaryProducts(data.products);
    })
    .catch((e) => {
      console.error('Complementary products error', e);
    });
}

function renderComplementaryProducts(products) {
  const container = document.getElementById('cart-drawer-complementary');
  if (!container) return;

  if (!products || !products.length) {
    container.innerHTML = '';
    return;
  }

  const isMobile = window.matchMedia("(max-width: 640px)").matches;
  const limit = isMobile ? 1 : 3;

  container.innerHTML = `
    <h3 class="comp-title">Complete Your Setup (10% off 3 Items or More)</h3>
    <div class="comp-grid">
      ${products
        .slice(0, limit) // <-- 1 on mobile, 3 on desktop
        .map((p) => `
          <div class="comp-item">
            <a href="${p.url}" class="comp-link">
              <img src="${p.featured_image}" alt="${p.title}" class="comp-img">
              <p class="comp-title-text">${p.title}</p>
              <p class="comp-price">${(p.price / 100).toFixed(2)} ${Shopify.currency.active}</p>
            </a>
          </div>
        `)
        .join('')}
    </div>
  `;
}

